/*!
  Pioneer WFRIA Pill v4.0.0-beta.53
  © 2023 Wells Fargo. All rights reserved.
*/
try {
  if (!window.__PIONEER_GLOBAL__) {
    window.__PIONEER_GLOBAL__ = {
      version: "4.0.0-beta.53",
      components: ["Pill"]
    };
  } else if (window.__PIONEER_GLOBAL__.components && window.__PIONEER_GLOBAL__.components.indexOf("Pill") < 0) {
    window.__PIONEER_GLOBAL__.components.push("Pill");
  }
} catch (error) {
  // catching server side rendering issues - windows is not defined there!
}

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "className", "description", "spacing", "theme"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useTheme } from "@emotion/react";
import PropTypes from "prop-types";
import React from "react";
import Box from "../private/Box/Box";
import { DEFAULT_THEME } from "./constants";
import extractTheme from "./extractTheme";
/**
 * The Pill component is a small highlight that is displayed inside
 * or in close proximity to another larger component or data,
 * representing a status, property, or some other information.
 * The Pill displays information about an item via text label.
 */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

function Pill(_ref) {
  let {
    children,
    className,
    description,
    spacing,
    theme
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  const internalTheme = useTheme();
  const {
    cssRoot,
    cssBox
  } = extractTheme({
    internalTheme,
    theme
  });
  return _jsx(Box, {
    spacing: spacing,
    theme: internalTheme,
    className: className,
    css: cssBox,
    children: _jsxs("div", _objectSpread(_objectSpread({
      css: cssRoot
    }, otherProps), {}, {
      role: "text" // eslint-disable-line jsx-a11y/aria-role
      ,
      children: [description && _jsx("span", {
        className: "wf-u-visually-hidden",
        children: `${description}, `
      }), _jsx("span", {
        children: children
      })]
    }))
  });
}

Pill.propTypes = process.env.NODE_ENV !== "production" ? {
  /** This is what will be displayed inside the component. */
  children: PropTypes.string.isRequired,

  /** className of the Container */
  className: PropTypes.string,

  /**
   * Description of the Pill.
   */
  description: PropTypes.string,

  /**
   * Custom spacing for the component. See the
   * "Customization -> Spacing" section.
   */
  spacing: PropTypes.oneOfType([PropTypes.number, PropTypes.shape()]),

  /** Theme of the Pill. */
  theme: PropTypes.oneOf(["utility", "information", "warning", "success", "error", "inverse"])
} : {};
Pill.defaultProps = {
  className: null,
  description: null,
  spacing: {},
  theme: DEFAULT_THEME
};
Pill.displayName = "Pill";
export default Pill;